import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783350b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["checked", "onChange"]
const _hoisted_4 = {
  key: 0,
  class: "multi-select__empty"
}

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { ChevronDownIcon } from '@zhuowenli/vue-feather-icons';

export interface MultiSelectOption {
  value: string;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSelect',
  props: {
    options: null,
    modelValue: null,
    placeholder: null,
    label: null,
    inline: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: MultiSelectOption[];
  modelValue: string[];
  placeholder?: string;
  label?: string;
  /* Panel im Textfluss aufklappen statt absolut positioniert —
     verhindert Abschneiden in scrollenden Modals */
  inline?: boolean;
}





const open = ref(false);
const rootEl = ref<HTMLElement | null>(null);

const triggerText = computed(() => {
  if (props.modelValue.length === 0) return props.placeholder ?? 'Bitte wählen…';
  if (props.modelValue.length === 1) {
    const found = props.options.find((o) => o.value === props.modelValue[0]);
    return found ? found.label : '1 ausgewählt';
  }
  return `${props.modelValue.length} ausgewählt`;
});

function toggle(value: string) {
  const next = props.modelValue.includes(value)
    ? props.modelValue.filter((v) => v !== value)
    : [...props.modelValue, value];
  emit('update:modelValue', next);
}

function onDocumentClick(e: MouseEvent) {
  if (open.value && rootEl.value && !rootEl.value.contains(e.target as Node)) {
    open.value = false;
  }
}

onMounted(() => document.addEventListener('click', onDocumentClick));
onBeforeUnmount(() => document.removeEventListener('click', onDocumentClick));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "multi-select",
    ref_key: "rootEl",
    ref: rootEl
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "multi-select__trigger",
      "aria-expanded": open.value ? 'true' : 'false',
      "aria-haspopup": "true",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value)),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (open.value = false), ["esc"]))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["multi-select__value", { 'multi-select__value--placeholder': __props.modelValue.length === 0 }])
      }, _toDisplayString(_unref(triggerText)), 3),
      _createVNode(_unref(ChevronDownIcon), {
        size: "16",
        class: _normalizeClass(["multi-select__chevron", { 'multi-select__chevron--open': open.value }])
      }, null, 8, ["class"])
    ], 40, _hoisted_1),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["multi-select__panel", { 'multi-select__panel--inline': __props.inline }]),
          role: "group",
          "aria-label": __props.label
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (o) => {
            return (_openBlock(), _createElementBlock("label", {
              key: o.value,
              class: "multi-select__option"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: __props.modelValue.includes(o.value),
                onChange: ($event: any) => (toggle(o.value))
              }, null, 40, _hoisted_3),
              _createElementVNode("span", null, _toDisplayString(o.label), 1)
            ]))
          }), 128)),
          (__props.options.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Keine Einträge vorhanden."))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true)
  ], 512))
}
}

})